import { render, staticRenderFns } from "./PolicyText.vue?vue&type=template&id=71f36d0b&scoped=true"
import script from "./PolicyText.vue?vue&type=script&lang=js"
export * from "./PolicyText.vue?vue&type=script&lang=js"
import style0 from "./PolicyText.vue?vue&type=style&index=0&id=71f36d0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f36d0b",
  null
  
)

export default component.exports